import { lazy } from 'react';

export const TournamentDashboardPageAsync = lazy(() =>
  import('./TournamentDashboardPage').then((m) => ({ default: m.TournamentDashboardPage })),
);
